import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Home from "./Components/Home";
import Events from "./Components/Events";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import About from "./Components/About";
import Resources from "./Components/Resources";

function App() {

  return (
    <>
      <Header />

      <BrowserRouter>
        <Routes>
          <Route path={`${process.env.PUBLIC_URL}/`} element={<Home/>}/>
          <Route path={`${process.env.PUBLIC_URL}/about`} element={<About/>}/>
          <Route path={`${process.env.PUBLIC_URL}/events`} element={<Events/>}/>
          <Route path={`${process.env.PUBLIC_URL}/resources`} element={<Resources/>}/>
        </Routes>
      </BrowserRouter>

      <Footer />
    </>
  );
}

export default App;
